import { render, staticRenderFns } from "./StaffInfo.vue?vue&type=template&id=b974101c&"
import script from "./StaffInfo.vue?vue&type=script&lang=js&"
export * from "./StaffInfo.vue?vue&type=script&lang=js&"
import style0 from "./StaffInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports